import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const serverUrl = "/api";

const PartnerDashboard = () => {
    const [codes, setCodes] = useState([]);
    const [credits, setCredits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [withdrawMessage, setWithdrawMessage] = useState('');
    const navigate = useNavigate();

    const partnerName = localStorage.getItem('partner_name');

    useEffect(() => {
        const fetchDashboard = async () => {
            const token = localStorage.getItem('partner_token');
            if (!token) {
                navigate('/partner');
                return;
            }
            try {
                const res = await fetch(serverUrl + '/partner/dashboard', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ token })
                });
                if (res.ok) {
                    const data = await res.json();
                    setCodes(data.codes);
                    setCredits(data.credits);
                } else {
                    localStorage.removeItem('partner_token');
                    navigate('/partner');
                }
            } catch (err) {
                setError('Failed to fetch dashboard data');
            } finally {
                setLoading(false);
            }
        };
        fetchDashboard();
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('partner_token');
        localStorage.removeItem('partner_name');
        navigate('/partner');
    };

    const handleWithdraw = async () => {
        if (window.confirm("Are you sure you want to request a withdrawal of your collected amount?")) {
            const token = localStorage.getItem('partner_token');
            try {
                const res = await fetch(serverUrl + '/partner/withdraw', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ token })
                });
                if (res.ok) {
                    setWithdrawMessage("Request received, we will contact you soon for the details.");
                } else {
                    alert("Failed to submit request. Please try again.");
                }
            } catch (err) {
                alert("An error occurred. Please try again later.");
            }
        }
    };

    if (loading) return <div style={{ padding: '20px' }}>Loading...</div>;
    if (error) return <div style={{ padding: '20px', color: 'red' }}>{error}</div>;

    const totalEarned = credits.reduce((sum, c) => sum + parseFloat(c.partner_earned), 0);

    return (
        <div style={{ padding: '40px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <h1 style={{ color: '#a239ca' }}>Welcome, {partnerName}</h1>
                <button onClick={handleLogout} style={{ padding: '10px 20px', backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>Logout</button>
            </div>

            <div style={{ display: 'flex', gap: '20px', marginBottom: '40px' }}>
                <div style={{ flex: 1, background: '#f9f9f9', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
                    <h3 style={{ margin: '0 0 10px 0', color: '#555' }}>Total Earned Credit</h3>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <p style={{ fontSize: '36px', fontWeight: 'bold', margin: 0, color: '#2ecc71' }}>{totalEarned.toFixed(2)} EUR</p>
                        {totalEarned >= 10 && (
                            <button 
                                onClick={handleWithdraw} 
                                style={{ padding: '10px 15px', backgroundColor: '#a239ca', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
                                Withdraw
                            </button>
                        )}
                    </div>
                    {withdrawMessage && <p style={{ color: 'green', marginTop: '10px', fontSize: '14px', fontWeight: 'bold' }}>{withdrawMessage}</p>}
                </div>
                <div style={{ flex: 1, background: '#f9f9f9', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
                    <h3 style={{ margin: '0 0 10px 0', color: '#555' }}>Total Usages</h3>
                    <p style={{ fontSize: '36px', fontWeight: 'bold', margin: 0, color: '#3498db' }}>{credits.length}</p>
                </div>
            </div>

            <h2>Your Discount Codes</h2>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '40px' }}>
                <thead>
                    <tr style={{ background: '#a239ca', color: '#fff' }}>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Code</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Customer Discount</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Your Share</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Status</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Printable Apartment Flyers</th>
                    </tr>
                </thead>
                <tbody>
                    {codes.map(c => (
                        <tr key={c.id} style={{ borderBottom: '1px solid #ddd' }}>
                            <td style={{ padding: '10px', fontWeight: 'bold' }}>{c.code}</td>
                            <td style={{ padding: '10px' }}>{c.reduction_percent}%</td>
                            <td style={{ padding: '10px' }}>{c.partner_percent}%</td>
                            <td style={{ padding: '10px', color: c.is_active ? 'green' : 'red' }}>{c.is_active ? 'Active' : 'Inactive'}</td>
                            <td style={{ padding: '10px' }}>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <a href={`/api/download-flyer?code=${c.code}&format=A4`} target="_blank" rel="noreferrer" style={{ padding: '5px 10px', backgroundColor: '#4CAF50', color: '#fff', borderRadius: '4px', textDecoration: 'none', fontSize: '12px', fontWeight: 'bold' }}>Download A4</a>
                                    <a href={`/api/download-flyer?code=${c.code}&format=A5`} target="_blank" rel="noreferrer" style={{ padding: '5px 10px', backgroundColor: '#2196F3', color: '#fff', borderRadius: '4px', textDecoration: 'none', fontSize: '12px', fontWeight: 'bold' }}>Download A5</a>
                                    <a href={`/api/download-flyer?code=${c.code}&format=A6`} target="_blank" rel="noreferrer" style={{ padding: '5px 10px', backgroundColor: '#9C27B0', color: '#fff', borderRadius: '4px', textDecoration: 'none', fontSize: '12px', fontWeight: 'bold' }}>Download A6</a>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <h2>Recent Code Usages</h2>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ background: '#333', color: '#fff' }}>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Date</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Code Used</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Game</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Base Price</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Earned</th>
                    </tr>
                </thead>
                <tbody>
                    {credits.map(c => (
                        <tr key={c.id} style={{ borderBottom: '1px solid #ddd' }}>
                            <td style={{ padding: '10px' }}>{new Date(c.created_at).toLocaleString()}</td>
                            <td style={{ padding: '10px', fontWeight: 'bold', color: '#a239ca' }}>{c.code}</td>
                            <td style={{ padding: '10px' }}>{c.game_title}</td>
                            <td style={{ padding: '10px' }}>{c.original_price} EUR</td>
                            <td style={{ padding: '10px', color: '#2ecc71', fontWeight: 'bold' }}>+{c.partner_earned} EUR</td>
                        </tr>
                    ))}
                    {credits.length === 0 && (
                        <tr><td colSpan="5" style={{ padding: '10px', textAlign: 'center' }}>No usages yet.</td></tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default PartnerDashboard;
